import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import { LoadingBar } from 'view-design'
import store from '@/store'

// 解决重复点击菜单抛出异常
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// 合并所有的路由配置文件
let allMenus = routes

Vue.use(Router)

const createRouter = () => {
  const router = new Router({
    mode: 'history',
    routes: allMenus,
  })

  router.beforeEach((to, from, next) => {
    const menuPower = store.getters.getMenuPower
    const btnPower = store.getters.btnPower
    LoadingBar.start()
    if (
      !window.localStorage.getItem('token') &&
      to.path !== '/login' &&
      to.meta.auth !== false
    ) {
      next('/login')
      return
    }
    if (to.path === '/') {
      if (btnPower.includes('srm:workbench:detail')) {
        next('/workbench')
      } else {
        next('/home')
      }
      return
    }
    let index = menuPower.findIndex(
      (item) =>
        item === to.path ||
        to.path.indexOf(item) > -1
    )
    if (index === -1) {
      if (btnPower.includes('srm:workbench:detail')) {
        next('/workbench')
      } else {
        next('/home')
      }
      return
    }
    next()
  })

  router.afterEach((to) => {
    LoadingBar.finish()
    window.scrollTo(0, 0)
  })

  return router
}

const router = createRouter()

export default router
